import { ServiceClient } from 'src/utils'
import { Nfe, NfeSinteseEvento } from './types'

const serviceClient = ServiceClient.singleton()

export class SerproService {
    static #INSTANCE = new SerproService()
    static readonly singleton = () => SerproService.#INSTANCE

    async fetchNfe(chaveNfe: string) {
        return serviceClient.authGet<Nfe>(`/api/serpro/v1/nfe/${chaveNfe}`)
    }

    async fetchEventosNfe(chaveNfe: string) {
        return serviceClient.authGet<NfeSinteseEvento[]>(`/api/serpro/v1/nfe/${chaveNfe}/eventos`)
    }
}

export default SerproService.singleton()
